var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_49657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9683 6.82572C13.9636 6.81355 13.9584 6.80159 13.9528 6.78981C13.332 5.50041 12.3658 4.40973 11.1588 3.63565C9.91859 2.84028 8.48085 2.41992 7.00106 2.41992C5.52128 2.41992 4.08347 2.84034 2.84329 3.63577C1.6407 4.40701 0.677206 5.49264 0.0561149 6.77584C-0.0134918 6.90917 -0.0186671 7.07037 0.0489989 7.21095C0.669766 8.50055 1.63598 9.59142 2.8431 10.3656C4.08334 11.1611 5.52115 11.5815 7.00106 11.5815C8.48092 11.5815 9.91872 11.1611 11.1589 10.3657C12.366 9.59155 13.3322 8.50074 13.953 7.21127C14.0111 7.09049 14.0165 6.9507 13.9683 6.82572ZM7.00106 10.6111C4.50512 10.6111 2.18682 9.20159 1.02938 7.00064C2.18682 4.79968 4.50512 3.39021 7.00106 3.39021C9.49694 3.39021 11.8153 4.79981 12.9727 7.0007C11.8152 9.20146 9.49688 10.6111 7.00106 10.6111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00148 4.87109C5.82735 4.87109 4.87207 5.82637 4.87207 7.0005C4.87207 8.17463 5.82735 9.12991 7.00148 9.12991C8.17561 9.12991 9.13089 8.17463 9.13089 7.0005C9.13089 5.82637 8.17561 4.87109 7.00148 4.87109ZM7.00148 8.15956C6.3624 8.15956 5.84242 7.63958 5.84242 7.0005C5.84242 6.36143 6.3624 5.84145 7.00148 5.84145C7.64056 5.84145 8.16054 6.36143 8.16054 7.0005C8.16054 7.63958 7.64056 8.15956 7.00148 8.15956Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_49657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookEye);
export default __webpack_public_path__ + "static/media/lookEye.19e4f851ae74a581256e93b23503abf1.svg";
export { ForwardRef as ReactComponent };